import React, { useCallback, useEffect, useRef, useState } from 'react'

import Controls from '@/Abondement/ECUsersAbondements/Controls'

import SearchBar from '@Pure/SearchBar'

import bemit from '@function/bemit'

const { app } = window;

export default function Filters ({ ...props })
{
	const [searched, setSearched] = useState('');
	const [instant_search, setInstantSearched] = useState('');

	const _timeout = useRef();
	const _refs = useRef();

	useEffect(function ()
	{
		_refs.current = _refs.current || { };

		_refs.current.onSearch = props.onSearch;
	},
	[props.onSearch]);

	const handleSearch = useCallback(function (value, search)
	{
		setSearched(value || '');

		if (_timeout.current)
		{
			window.clearTimeout(_timeout.current);
		}

		_timeout.current = window.setTimeout(function ()
		{
			_timeout.current = null;

			setInstantSearched(value);
		},
		500);
	},
	[]);

	useEffect(function ()
	{
		if (!_refs.current.searched_once)
		{
			_refs.current.searched_once = true;

			return;
		}

		_refs.current.onSearch(instant_search);
	},
	[instant_search]);

	return (
		<div className="u-negative-margins">
			<div className="o-grid">

				<div className="o-grid__item-8 u-text-right">
					<h2 className="c-title u-margin-top-0">
						<span className="c-title__txt">
							Modifier un ou des abondements
						</span>
					</h2>

					<Controls selected={ props.selected }
						onSuccess={ props.onUpdate }
						total={ app.state.session.EC?.abondement?.value }
					/>
				</div>

				<div className="o-grid__item-4">

					<SearchBar hide_btn={ true } placeholder="Recherche..."
						handleChange={ handleSearch }
						value={ searched }
						className={ bemit('c-searchbar', ['full-width']) }
					/>

				</div>

			</div>
		</div>
	);
}